/**
 * Injects promo info cards from metaobject data into the Globo
 * Smart Filter product grid (#gf-products).
 */
(function () {
  'use strict';

  const MARKER_CLASS = 'gf-info-card-wrapper';
  let debounceTimer = null;
  let observer = null;

  function getCardData() {
    const el = document.getElementById('globo-promo-cards-data');
    if (!el) return [];
    try { return JSON.parse(el.textContent) || []; }
    catch (e) { return []; }
  }

  function escAttr(str) {
    return String(str || '').replace(/&/g, '&amp;').replace(/"/g, '&quot;').replace(/</g, '&lt;');
  }

  function buildCardHTML(card) {
    const hasBadge = card.badge_text && card.badge_text.trim() !== '';
    const hasImage = card.image_url && card.image_url.trim() !== '';
    const hasButton = card.button_text && card.button_text.trim() !== '';
    const colorScheme = card.color_scheme || 'scheme-4';

    let html = '<div class="info-card' + (hasBadge ? ' info-card--with-badge' : '') + ' color-' + escAttr(colorScheme) + ' gradient">';

    if (hasImage) {
      html += '<div class="info-card__image-wrapper' + (hasBadge ? ' info-card__image-wrapper--badge' : '') + '">';
      html += '<img';
      if (card.image_srcset) html += ' srcset="' + escAttr(card.image_srcset) + '"';
      html += ' src="' + escAttr(card.image_url) + '"';
      html += ' sizes="100vw"';
      html += ' alt="' + escAttr(card.image_alt) + '"';
      html += ' loading="lazy" class="info-card__image">';
      html += '</div>';
    }

    html += '<div class="info-card__content"><div class="info-card__text">';

    if (hasBadge) {
      html += '<span class="info-card__badge" style="background-color: ' + escAttr(card.badge_color) + ';">';
      html += escAttr(card.badge_text) + '</span>';
    }

    if (card.title) html += '<h3 class="info-card__title">' + escAttr(card.title) + '</h3>';
    if (card.subtitle) html += '<p class="info-card__description">' + escAttr(card.subtitle) + '</p>';

    html += '</div>';

    if (hasButton) {
      html += '<a href="' + escAttr(card.button_link || '#') + '" class="info-card__button">';
      html += escAttr(card.button_text) + '</a>';
    }

    html += '</div></div>';
    return html;
  }

  function injectCards() {
    const container = document.getElementById('gf-products');
    if (!container || !document.querySelector('.spf-has-filter')) return;

    const cards = getCardData();
    if (!cards.length) return;

    const existing = container.querySelectorAll('.' + MARKER_CLASS);
    if (existing.length === cards.length) return;

    if (observer) observer.disconnect();

    existing.forEach((el) => el.remove());
    cards.sort((a, b) => a.position - b.position);

    const productItems = Array.from(container.querySelectorAll(':scope > :not(.' + MARKER_CLASS + ')'));

    const isMobile = window.innerWidth < 990;

    cards.forEach((card) => {
      const pos = Math.max(card.position, 1);
      const wrapper = document.createElement('div');
      wrapper.className = MARKER_CLASS;
      wrapper.innerHTML = buildCardHTML(card);

      if (isMobile) {
        const rowEnd = Math.ceil(pos / 2) * 2;
        const insertAfterIdx = Math.min(rowEnd, productItems.length) - 1;
        const afterEl = productItems[insertAfterIdx];
        if (afterEl) {
          afterEl.parentNode.insertBefore(wrapper, afterEl.nextSibling);
        } else {
          container.appendChild(wrapper);
        }
      } else {
        // On desktop, card takes the exact position
        if (pos - 1 < productItems.length) {
          productItems[pos - 1].parentNode.insertBefore(wrapper, productItems[pos - 1]);
        } else {
          container.appendChild(wrapper);
        }
      }
    });

    startObserver();
  }

  function scheduleInject() {
    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(injectCards, 350);
  }

  function startObserver() {
    const target =
      document.getElementById('ProductGridContainer') ||
      document.querySelector('.gf-products-wrapper') ||
      document.querySelector('.collection');
    if (!target) return;

    if (observer) observer.disconnect();

    observer = new MutationObserver((mutations) => {
      for (let i = 0; i < mutations.length; i++) {
        if (mutations[i].type === 'childList' && mutations[i].addedNodes.length) {
          let isOwnNode = false;
          mutations[i].addedNodes.forEach((node) => {
            if (node.classList && node.classList.contains(MARKER_CLASS)) isOwnNode = true;
          });
          if (!isOwnNode) {
            scheduleInject();
            return;
          }
        }
      }
    });

    observer.observe(target, { childList: true, subtree: true });
  }

  function init() {
    injectCards();
    startObserver();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  function removeAndReinject() {
    const container = document.getElementById('gf-products');
    if (container) container.querySelectorAll('.' + MARKER_CLASS).forEach((el) => el.remove());
    scheduleInject();
  }

  document.addEventListener('globo:filter:done', removeAndReinject);
  document.addEventListener('globo:search:done', removeAndReinject);
})();
